// 用户相关信息仓库

import {
  loginByUsername,
  logout,
  getUserMenu,
  getInfoByUser
} from "@/api/login";
import {
  getToken,
  setToken,
  removeUserInfo,
  setUserId,
  getUserId,
  setUserName,
  getUserName,
  getModelId,
  setUserFunction,
  getUserFunction,
  getUserAvatar,
  setUserAvatar
} from "@/utils/auth";
import { clearData } from "./clearData";

const user = {
  state: {
    token: getToken(),
    id: getUserId(),
    name: getUserName(),
    userFunction: getUserFunction(),
    roleId: localStorage.getItem("roleId"),
    email: localStorage.getItem("email"),
    avatar: getUserAvatar(),
    userMenu: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_ID: (state, id) => {
      state.id = id;
    },
    SET_USER_NAME: (state, name) => {
      state.name = name;
    },
    SET_USER_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    // SET_USER_EMAIL: (state, email) => {
    //   state.email = email;
    // },
    SET_USER_ROLEID: (state, roleId) => {
      localStorage.setItem("roleId", roleId);
      state.roleId = roleId;
    },
    SET_USER_EMAIL: (state, email) => {
      localStorage.setItem("email", email);
      state.email = email;
    },
    SET_USER_FUNCTION: (state, userFunction) => {
      state.userFunction = userFunction;
    },
    SET_USER_MENU: (state, userMenu) => {
      state.userMenu = userMenu;
    }
  },

  actions: {
    SetUserToken({ commit }, params) {
      setToken(params);
      commit("SET_TOKEN", params);
    },
    SetUserId({ commit }, params) {
      setUserId(params);
      commit("SET_USER_ID", params);
    },
    SetUserName({ commit }, params) {
      setUserName(params);
      commit("SET_USER_NAME", params);
    },
    SetUserAvatar({ commit }, params) {
      setUserAvatar(params);
      commit("SET_USER_AVATAR", params);
    },
    SetUserEmail({ commit }, params) {
      commit("SET_USER_EMAIL", params);
    },
    RoleId({ commit }, params) {
      commit("SET_USER_ROLEID", params);
    },
    // 用户可用功能
    SetUserFunction({ commit }, params) {
      setUserFunction(params);
      commit("SET_USER_FUNCTION", params);
    },
    // 用户名登录
    LoginByUsername({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginByUsername(params)
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取用户菜单
    GetUserMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = {};
        getUserMenu(params)
          .then(res => {
            if (res.data.status == 200) {
              if (res.data.data && res.data.data.length) {
                commit("SET_USER_MENU", res.data.data);
                resolve(res.data.data);
              } else {
                commit("SET_USER_MENU", []);
                resolve([]);
              }
            }
          })
          .catch(error => {
            commit("SET_USER_MENU", []);
            reject(error);
          });
      });
    },

    // 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        clearData();
        resolve();
      });
    },
    // 清空本地信息
    ClearUser({ commit }) {
      commit("SET_USER_NAME", "");
      commit("SET_USER_ID", "");
      commit("SET_TOKEN", "");
      commit("SET_USER_FUNCTION", "");
      //   commit("SET_USER_EMAIL", "");
      removeUserInfo();
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js